module.exports = require("ngx-bootstrap/dropdown");